// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2cg1F","clinicsSelect":"TableHeading_clinicsSelect__3zwqN"};